<template>
  <div id="issue-list">
    <v-data-table
      :headers="headers"
      :items="issues"
      class="elevation-1"
    >
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{props.header.text}}
          </span>
          <span>
            {{props.header.text}}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props" >
        <tr @click="props.expanded = !props.expanded">
          <td>{{props.item.title}}</td>
          <td class="text-xs-left">{{props.item.category}}</td>
          <td class="text-xs-left">{{props.item.priority}}</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <v-card flat dark>
          <v-container fluid>
            <v-layout wrap>
              <v-card-text>
                <v-flex>
                  <b style="color:#ff8080;">@{{props.item.email.split('@')[0]}} submitted: </b>{{props.item.description}}
                </v-flex>
              </v-card-text>
            </v-layout>
          </v-container>
        </v-card>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'title'
        },
        { text: 'Category', value: 'category' },
        { text: 'Priority', value: 'priority' }
      ]
    }
  },
  methods: {
    getIssues: function () {
      var issues = this.$store.getters.issues
      return (this.$store.getters.issues) ? issues : []
    }
  },
  computed: {
    issues: function () {
      return this.getIssues()
    }
  },
  watch: {
    issues: function () {
      // Respond when the issues computed property changes
      console.log("issues changed")
      console.log(this.issues)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/dashboard/lists/IssueList.vue